module.exports = __webpack_public_path__ + "static/img/about_client.9d1ebdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about_client.jpg
// module id = lsLS
// module chunks = 0